import moment from 'moment';
import { createSelector } from 'reselect';

import { getSelectedStructure } from '@sophocles/features/sites/slices/selectedStructure/selectors';

export const internationalMeterReadingSelector = state => state.entities.internationalMeterReadings;

const getInternationalMeterReadings = createSelector(internationalMeterReadingSelector, readings =>
  readings.map(reading => reading.set('timestamp', moment(reading.get('timestamp')))),
);

export const getInternationalMeterReadingsForSelectedSite = createSelector(
  getSelectedStructure,
  getInternationalMeterReadings,
  (structure, readings) => {
    const site_id = structure.get('id', 0);
    return readings.filter(entry => entry.get('site', -1) == site_id).toList();
  },
);
